import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

export interface DealMetrics {
  deal_id: string;
  deal_name: string;
  stage: string;
  total_amount: number;
  win_probability: number;
  contact_id: string;
  deal_created_at: string;
  last_activity_at?: string;
  deal_age_days: number;
  days_since_last_activity?: number;
  total_calls: number;
  scheduled_meetings_count: number;
  completed_meetings_count: number;
  missed_meetings_count: number;
  total_meetings: number;
  scheduled_tasks_count: number;
  overdue_tasks_count: number;
  completed_tasks_count: number;
  total_payments: number;
  paid_payments_count: number;
  overdue_payments_count: number;
  total_paid_amount: number;
  total_balance: number;
  total_contracts: number;
  signed_contracts_count: number;
  pending_contracts_count: number;
  pending_confirmations_count: number;
  health_score: number;
}

export function useDealMetrics(dealId?: string) {
  const [metrics, setMetrics] = useState<DealMetrics | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const loadMetrics = async () => {
    if (!dealId) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const { data, error: fetchError } = await supabase
        .from('deal_metrics')
        .select('*')
        .eq('deal_id', dealId)
        .single();

      if (fetchError) throw fetchError;
      setMetrics(data);
    } catch (err) {
      setError(err as Error);
      console.error('Error loading deal metrics:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadMetrics();
  }, [dealId]);

  return {
    metrics,
    loading,
    error,
    loadMetrics,
  };
}
